import React, { useState, useEffect } from "react";
import styled from "styled-components";
import { CardElement, useStripe, useElements } from "@stripe/react-stripe-js";

import Title from "../Text/Title/Title";

import Impact from "./Impact/Impact";
import PaymentDetails from "./PaymentDetails/PaymentDetails";
import ThankYou from "../ThankYou/ThankYou";

import { StyledInput } from "../../Styled-Components/styles";
import * as api from "../../Functions/api";

const StyledForm = styled.form`
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: center;

  font-size: 22px;
  font-weight: 600;

  background-color: ${(props) => props.theme.palette.primary.main};
  color: white;

  border-radius: ${(props) => props.theme.border.radius};
  box-shadow: ${(props) =>
    props.theme.border.shadow + props.theme.palette.primary.main};

  padding: 1vh 1vh;

  margin: 0 auto;
  width: 80vw;
`;

const Donation = (props) => {
  const stripe = useStripe();
  const elements = useElements();

  const [clientSecret, setClientSecret] = useState(null);
  const [error, setError] = useState(null);
  const [paymentComplete, setPaymentComplete] = useState(null);
  const [email, setEmail] = useState(null);
  const [processing, setProcessing] = useState(false);
  const [mapDetails, setMapDetails] = useState({
    name: "An Anonymous Supporter",
    displayName: false,
  });

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (!stripe || !elements) {
      return;
    }
    if (props.payment < 5) {
      setError("The minimum donation is £5");
      return;
    }
    if (error) {
      elements.getElement(CardElement).focus();
      return;
    }
    try {
      setProcessing(true);
      const payload = await stripe.confirmCardPayment(clientSecret, {
        receipt_email: email,
        payment_method: {
          type: "card",
          card: elements.getElement(CardElement),
        },
      });
      if (payload.error) {
        setError(payload.error.message);
        setProcessing(false);
      } else {
        if (payload.paymentIntent.status === "succeeded") {
          setPaymentComplete(payload.paymentIntent);
        }
      }
    } catch (err) {
      console.log(err);
      console.log("Unexpected Error");
      setError("Something went wrong");
    }
  };
  useEffect(() => {
    setError(null);
  }, [props.payment]);
  useEffect(() => {
    setProcessing(false);
  }, [error]);
  useEffect(() => {
    api
      .makePaymentIntent(props.payment)
      .then((data) => setClientSecret(data.paymentIntent.client_secret))
      .then(() => console.log("New Payment Intent"))
      .catch((err) => console.log(err));
  }, [props.payment]);

  return paymentComplete ? (
    <ThankYou />
  ) : (
    <StyledForm onSubmit={handleSubmit}>
      <Title
        title="Grow your own Forest"
        subheading="All forests have to start somewhere"
      />
      <Impact
        setPayment={props.setPayment}
        payment={props.payment}
        mapDetails={mapDetails}
        setMapDetails={setMapDetails}
      />
      <PaymentDetails
        error={error}
        serError={setError}
        stripe={stripe}
        processing={processing}
        clientSecret={clientSecret}
        payment={props.payment}
        mapDetails={mapDetails}
        setMapDetails={setMapDetails}
      />
    </StyledForm>
  );
};

export default Donation;
